import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCHookToast, RCCHTMLTextEditor, RCCRefModalProps, RCCServicesApi, RCCSwitch, RCCTextArea } from "react-common-components";
import { useForm } from "react-hook-form";
import Modal from "src/components/Modal";
import { ModalCenter } from "src/components/Modal/styles";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import { IParticipantInfo, IRefModalParticipantAttend } from "../../interface";

const ModalParticipantAttend: React.ForwardRefRenderFunction<IRefModalParticipantAttend> = (_,ref) => {

	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();
	const { setLoading } = useLoaderBackdrop();
    
	const controllerUrl = "Meetings/";
	const [participantInfo, setParticipantInfo] = useState<IParticipantInfo>();
	const [onCloseFunction,setOnCloseFunction] = useState<(()=>void )>();

	const modalParticipantInfo = useRef<RCCRefModalProps>(null);
	const { 
		handleSubmit, 
		control,
		register, 
		reset, 
		setError, 
		clearErrors
	} = useForm();

	const actionButtonOpen = async(id:number,onClose?:()=>void) => {
		try {
			setLoading(true);
			reset();
			await requestParticipantInfo(id);
			setOnCloseFunction(() => onClose);
			setLoading(false);
			modalParticipantInfo.current?.openModal();
		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar dados"), addToast);
			setLoading(false);
		}
	};

	const requestParticipantInfo = async(id:number) =>
	{
			
		const {data} = await RCCServicesApi.getRequest({
			method: `${controllerUrl}SelectParticipantInfo`,
			urlParameters:{id}
		});
		setParticipantInfo(data);
		
	};

	const submitInfo = async (data: any) => {
		try{
			clearErrors();
			modalParticipantInfo.current?.setLoadingButton();
			const dataForm = {...participantInfo,...data};

			await RCCServicesApi.postRequest({
				method: `${controllerUrl}UpdateParticipantInfo`,
				urlParameters: {
					...dataForm,
					ara002Presente:data.ara002Presente ? "S" : "N",
					ara002Acordoata:data.ara002Acordoata ? "S" : "N"
				}
			});

			addToast({
				color: "green",
				description: translate("Informação do participante alterado com sucesso" ),
				title: translate("Sucesso")
			});

			if(onCloseFunction)
				onCloseFunction();

			modalParticipantInfo.current?.resetLoadingButton();
			modalParticipantInfo.current?.closeModal();
			

		}catch(err){

			modalParticipantInfo.current?.resetLoadingButton();
			if(getValidationErrors(err, setError))
				return;

			standardErrorMessages(err, translate("Erro ao alterar informação do participante"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		actionButtonOpen
	}));

	return (
		<Modal
			ref={modalParticipantInfo}
			header={{
				title:translate("Informações do participante"),
				icon:{name:"user"}
			}}
			styleInline={`${ModalCenter} height: 600px;`}
			onSubmit = {handleSubmit(submitInfo)}
		>
			<RCCGrid
				container
				justifyContent="center"
			>
				<RCCGrid container item sm={10}>
					<RCCHTMLTextEditor
						control={control}
						name="ara001Ata"
						label={translate("Ata")}
						defaultValue={participantInfo?.ara001Ata}
						disabled
					/>
					<RCCGrid container justifyContent="space-between"> 
						<RCCSwitch
							name="ara002Presente"
							register={register}
							label={translate("Esteve Presente")}
							defaultChecked={participantInfo?.ara002Presente === "S"}
						/>
						<RCCSwitch
							name="ara002Acordoata"
							register={register}
							label={`${translate("Concorda com a ata")} ?`}
							defaultChecked={participantInfo?.ara002Acordoata === "S"}
						/>
					</RCCGrid>
					<RCCGrid container> 
						<RCCTextArea
							name="ara002Comentario"
							register={register}
							label={translate("Comentário")}
							defaultValue={participantInfo?.ara002Comentario}
							maxLength={4000}
						/>
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</Modal>
	);
};

export default forwardRef(ModalParticipantAttend);
